export default {
	"lang": "th",
	"page-title": "การวิเคราะห์ตลาด",
}